<template>
  <div v-loading="loading" class="feeds">

    <template v-if="!listView">
      <div class="feeds-page">
        <!--feed-filter
            v-if="userFeeds.length > 1"
            :key="`filter-${index}`"
            :user="index"
            @onFilter="handlerFilter"
          />
          <div></div-->
        <template v-for="(userFeeds, index) in page">
          <div :key="index">
            <!--feed-header :user-name="index.toString()" /-->

            <div
              class="feeds-card-wrap feeds-card-wrap--users"
              :key="userFeeds.id"
            >
              <feed-card
                :feeds="userFeeds"
                :loadAdditional="isLoadAdditional(userFeeds)"
                :current-page="currentPage"
                :has-search="hasSearch"
              />
            </div>
          </div>
        </template>
      </div>
      <pagination
        v-if="!showPagination"
        :feeds="mainFeeds"
        :page-size="pageSize"
        :current-page="currentPage"
        @currentChange="setPage"
      />
    </template>
    <template v-else>
      <feed-list :feeds="feeds" />
    </template>

    <search-not-found v-if="showNotFound" />
  </div>
</template>

<script>
// components
import FeedHeader from "../FeedHeader";
import FeedFilter from "../FeedFilter";
import FeedCard from "../feedCard/FeedCard";
import Pagination from "../../../../components/pagination/Pagination";
import SearchNotFound from "../../../../components/SearchNotFound";
import feedListView from "@/components/feedListView";
import feedList from "../feedList";

// vuex
import { mapGetters } from "vuex";

// mixins
import { threads } from "../../../../mixins/threads";

export default {
  name: "AdminFeedList",
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      usersFilter: [],
      page: [],
      defaultFilter: "bottom",
    };
  },
  computed: {
    ...mapGetters(["isHomePage", "listView"]),
  },
  methods: {
    handlerFilter({ filter, user }) {
      this.usersFilter[user] = filter;
      this.getPage();
    },
    setPage(value) {
      this.currentPage = value
      this.$emit("currentPage", value);
      window.scrollTo(0, 0);
      this.getPage();
    }
  },
  mounted() {
    this.getPage();
  },
  mixins: [threads],
  components: {
    FeedHeader,
    FeedFilter,
    FeedCard,
    Pagination,
    SearchNotFound,
    feedListView,
    feedList,
  },
};
</script>

<style>
.feeds {
  font-family: "Roboto", "Arial", sans-serif;
}

.feeds-page {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.feeds .el-loading-mask {
  margin:60px 0 0 0;
}
</style>
